<template>
  <loader-wrapper :loading="loading" style="position: relative">
    <yandex-map
      :settings="ymapSettings"
      :coords="center"
      :zoom.sync="zoom"
      :controls="controls"
      :cluster-options="clusterOptionsCalc"
      :use-object-manager="true"
      ymap-class="ymap-desktop"
      @map-was-initialized="mapLoaded"
    >
      <ymap-marker
        v-for="(bid, i) in items"
        :key="i"
        :marker-id="i"
        :coords="getCoords(bid)"
        :icon="getContentLayout(bid)"
        cluster-name="cluster"
        :balloon="renderBid(bid)"
      >
        <div slot="baloon">123</div>
      </ymap-marker>
    </yandex-map>
  </loader-wrapper>
</template>

<script>
import {
  MAP_CENTER,
  clusterOptionsCalc,
  markerCalcIcon,
  ymapSettings,
} from './constants'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import ResultsItem from '@/views/Calculator/components/ResultsItem'
import Vue from 'vue'

export default {
  name: 'DriversYMap',
  components: { LoaderWrapper },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      zoom: 8,
      controls: ['zoomControl', 'fullscreenControl'],
      center: MAP_CENTER,
      ymapSettings,
      markerCalcIcon,
      clusterOptionsCalc,
      map: null,
      loading: false,
    }
  },
  watch: {
    items() {
      if (this.map) {
        this.map.geoObjects.removeAll()
      }
    },
  },
  methods: {
    mapLoaded(e) {
      e.options.set('suppressMapOpenBlock', true)
      this.map = e
    },
    renderBid(bid) {
      const propsData = { balloon: true, config: this.config, item: bid }
      const text = bid[this.config.load] || ''
      const comp = new Vue({
        ...ResultsItem,
        parent: this,
        propsData,
      }).$mount()

      return { body: comp.$el.outerHTML, header: text.split(',')[0] }
    },
    getContentLayout(bid) {
      const text = bid[this.config.load] || ''
      const contentLayout = `<div class="ym-calc-marker">${
        text.split(',')[0]
      }</div>`

      return { ...this.markerCalcIcon, contentLayout }
    },
    getCoords(bid) {
      const { lat, lon } = this.config

      return [bid[lat] || '', bid[lon] || '']
    },
  },
}
</script>

<style lang="sass">
.ymap-desktop
  height: 95vh
.ym-calc-marker
  font-weight: bold
  color: #ff0000
  white-space: nowrap
  font-size: 12px
.calc-cluster-balloon
  max-height: 100%
  overflow: auto
  .ballon_body
    background: #F7F7F7
    border: 1px solid #D1D1D1
    border-radius: 5px
    margin-bottom: 15px
</style>
